import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: '1rem',
  },
  button: {
    fontWeight: '600',
    fontFamily: 'inherit',
    color: theme.palette.colors.darkGrey,
    fontSize: 'inherit',
    margin: '0 5px 0 5px',
    padding: '0',
  },
  centered: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
  },
}));
